<template>
	<div class="container">
		<div class="page-top">
			<div class="wrapper content">
				<div >
					<div class="title">探索软件新世界, 汇聚精品让您省心省力 ! </div>
					<div class="tip">根据真实评论找到合适的软件和服务</div>
					<div class="search">
						<el-input class="input-key" placeholder="请输入产品名称、软件类别、公司名称搜索" v-model="keyword"></el-input>
						<el-button type="warning" round @click="$router.push({name:'soft-search',params:{keyword:keyword}})">立即搜索</el-button>
					</div>
				</div>
				
			</div>
			
		</div>
		<div>
			<div class=" wrapper soft-wrapper">
				<div class="title">热门软件分类</div>
				<div class="typeList">
					<div class="classify-item" v-for="item in typeList" :class="{'actived':item.id == parentId}" @click="parentId = item.id;getTypeList({parentId:item.id})">{{item.typeName}}</div>
				</div>
				<div class="soft-content">
					<el-image class="bg" :src="require('@/assets/softWare/more-bg.png')" fit="cover"></el-image>
					<div class="sub-type">
						<div class="sub-item" v-for="item in subList" :class="{'actived':item.id == typeId}" @click="handleType(item.id)">{{item.typeName}}</div>
					</div>
					<div class="softList">
						
						<div class="soft-msg" v-for="item in dataList">
							<div class="logo">
								<el-image :src="item.logo" fit="scale-down"></el-image>
							</div>
							<div>
								<div class="name">{{item.name}}</div>
								<div class="rate"><el-rate v-model="value" disabled ></el-rate></div>
							</div>
							<div class="desc" style="-webkit-box-orient: vertical; white-space:pre-line;">{{item.baseInfo}}</div>
							<div class="soft-btn">
								<el-button size="mini" plain>咨询软件</el-button>
								<el-button size="mini" plain @click="toSoftDetail(item.id)">查看详情</el-button>
							</div>
						</div>
						<div class="btn" @click="$router.push({name:'soft-list',params:{parentId:parentId,typeId:typeId}})">
							<div class="more-title">更多智能化软件</div>
							<div class="more-tip">精心挑选广受用户认可的软件</div>
							<div class="more-link">点击进入&gt;</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="process">
			<div class="wrapper">
				<div class="title">我们的服务流程</div>
				<div class="process-wrapper">
					<div class="process-item">
						<div class="image"><el-image :src="require('@/assets/softWare/analysis.png')" fit="fill"></el-image></div>
						<div class="pro-title">需求分析</div>
					</div>
					<div><i class="iconfont icon-weibiaoti40"></i></div>
					<div class="process-item">
						<div class="image"><el-image :src="require('@/assets/softWare/survey.png')" fit="fill"></el-image></div>
						<div class="pro-title">市场调研</div>
					</div>
					<div><i class="iconfont icon-weibiaoti40"></i></div>
					<div class="process-item">
						<div class="image"><el-image :src="require('@/assets/softWare/evaluate.png')" fit="fill"></el-image></div>
						<div class="pro-title">评估厂商资质</div>
					</div>
					<div><i class="iconfont icon-weibiaoti40"></i></div>
					<div class="process-item">
						<div class="image"><el-image :src="require('@/assets/softWare/compare.png')" fit="fill"></el-image></div>
						<div class="pro-title">功能方案比较</div>
					</div>
					<div><i class="iconfont icon-weibiaoti40"></i></div>
					<div class="process-item">
						<div class="image"><el-image :src="require('@/assets/softWare/tryout.png')" fit="fill"></el-image></div>
						<div class="pro-title">试用演示</div>
					</div>
					<div><i class="iconfont icon-weibiaoti40"></i></div>
					<div class="process-item">
						<div class="image"><el-image :src="require('@/assets/softWare/contract.png')" fit="fill"></el-image></div>
						<div class="pro-title">合同签署</div>
					</div>
				</div>

			</div>
		</div>
		<div class="comment">
			<div class="wrapper">
				<div class="desc">
					<div class="title">为你使用过的软件撰写评论吧</div>
					<div class="tip">欢软已帮助近百家买家为他们的信息化业务做出正确的选择。</div>
					<div class="input-wrapper">
						<el-input class="input-key" placeholder="请输入软件名称" v-model="keyword">
							<i slot="prefix" class="el-input__icon el-icon-search"></i>
						</el-input>
						<el-button type="warning" round @click="$router.push({name:'soft-search',params:{keyword:keyword}})">前往撰写</el-button>
					</div>
				</div>
				<div class="image">
					<el-image :src="require('@/assets/softWare/comment.png')" fit="contain"></el-image>
				</div>
				
			</div>
		</div>
		<div>
			<div class="wrapper">
				<div class="title">专业交流群组保驾您的数字化旅程</div>
				<div class="group-wrapper">
					<div class="group-image">
						<el-image :src="require('@/assets/softWare/group.png')" fit="cover"></el-image>
					</div>
					<div class="group-list">
						<div class="group-item">
							<div class="group-title">市场营销交流群</div>
							<div class="group-desc">私域运营、潜客拓展、智能营销、舆情监测、客户体验管理等市场营销相关交流</div>
						</div>
						<div class="group-item">
							<div class="group-title">数据分析交流群</div>
							<div class="group-desc">数据分析、企业级搜索引擎、数据治理、低代码开发等数据处理与技术开发相关交流</div>
						</div>
						<div class="group-item">
							<div class="group-title">AI与智能技术交流群</div>
							<div class="group-desc">私域运营、潜客拓展、智能营销、舆情监测、客户体验管理等市场营销相关交流</div>
						</div>
						<div class="group-item">
							<div class="group-title">智能销售交流群</div>
							<div class="group-desc">客户管理系统、销售自动化、AI智能外呼、在线客服、售后服务等销售相关交流</div>
						</div>
						<div class="group-item">
							<div class="group-title">ERP与供应链交流群</div>
							<div class="group-desc">ERP系统、分销管理、生产物流、项目管理、资产管理等相关交流</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="anli">
			<div class="wrapper">
				<div class="title">客户案例</div>
				<div class="anli-wrapper">
					<div class="anli-item" v-for="(item,index) in anliList" :style="{'display':index>=4 ? 'none':'inline-block'}">
						<el-image class="cover-image" :src="item.cover" fit="fill"></el-image>
						<div class="title">{{item.title}}</div>
						<div class="abstrc" style="-webkit-box-orient: vertical;">{{item.summary}}</div>
						<div class="bottom">
							<div class="tag">{{ industryType[item.industryId] }}</div>
							<div class="link" @click="toDetail(item.id)">查看详情
								<div class="icon-bg">
									<i class="el-icon-right"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="btn">
					<el-button type="text" @click="$router.push({path:'/case'})">了解更多客户案例</el-button>
				</div>
			</div>
		</div>
		<div class="service">
			<div class="wrapper">
				<div class="title">更多相关服务</div>
				<div class="item-wrapper">
					<div class="item">
						<div class="item-title">快速开发平台：帮你实现</div>
						<div class="content">快速构建系统：使用预制组件和模板，迅速搭建系统<br/>
						降低开发成本：通过自动化工具，减少开发时间和人力成本<br/>
						提升系统稳定性：采用模块化设计和标准化组件<br/>
						便于系统扩展：支持灵活扩展机制，轻松增加新功能<br/>
						简化维护：通过标准化组件和模块化设计，降低后期维护复杂度<br/>
						提高开发效率：利用开发工具和预设模板，加速系统开发流程
						</div>
						<div class="button" @click="$router.push('/platform')">前往了解</div>
					</div>
					<div class="item">
						<div class="item-title">众包平台：帮你实现</div>
						<div class="content">灵活用工：按需雇佣专业人员，快速获取技术支持, 省时省力<br/>
						降低成本：按项目支付，减少全职员工和固定支出<br/>
						提高效率：利用平台工具，高效管理和完成项目<br/>
						拓展业务：通过平台合作，扩大业务和市场竞争力<br/>
						风险控制：通过合同和评价系统，降低项目风险<br/>
						质量保障：确保按时高质量交付，保障项目进度, 专业负责
						</div>
						<div class="button" @click="$router.push('/crowd')">前往了解</div>
					</div>
				</div>
			</div>
		</div>
		<div class="zixun">
			<div class="wrapper">
				<div class="title">热门资讯</div>
				<div class="zixun-msg" style="background-color: #FFFFFF; padding: 8px 8px 5px 30px; border-radius: 40px; display: inline-grid; grid-template-columns: auto 45%">
					<div class="topicList">
						<div style="padding: 0px 20px 20px 0px;" data-aos="zoom-in-right" data-aos-delay="300">
							<div v-for="item in list" class="topicItem" @mouseover="handleHover(item)" @click="toTopicDetail(item.id)"
								 :style="currentTopicId === item.id ? { background: 'rgba(255, 132, 68, 0.05)', padding: '20px', borderRadius: '20px', display:'block'  } : {}"
								 style="color: rgb(64, 64, 64); font-size: 18px; font-weight: 500; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden; margin-top: 10px;">
							  {{ item.title }}
			
							  <div v-if="currentTopicId === item.id"
								   style="font-size: 16px; color: rgb(109, 109, 109); letter-spacing: 1px; margin-top: 5px; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;">
								{{ item.description }}
							  </div>
							</div>
			
							<div v-if="list && list.length > 0" class="more" style="margin-top: 20px" @click="$router.push({name:'social',params:{typeId:topicType}})">查看更多&gt;&gt;</div>
						</div>
					</div>
					<div class="image" data-aos="flip-right" data-aos-delay="300" style="width: 100%">
					  <el-image :src="currentTopicSrc ? currentTopicSrc : require('@/assets/fengmian.jpeg')" fit="cover"></el-image>
					</div>
				</div>
			</div>
		</div>

		<Apply/>

	</div>
</template>

<script>
import { getList,getIndustry } from '@/api/anli/anli'
import { getType, getSoftList } from '@/api/software/index'
import { getTopicType,getTopicList } from '@/api/social/index'
import { getIsTrial, getToken } from '@/utils/auth'
import { toLogin } from '@/api/isLogin'
import Apply from "@/components/Apply.vue";
export default {
  components: {
    Apply,
  },
  data () {
    return {
      dataList:[],
	  typeList:[],
	  subList: [],
	  anliList:[],
	  list:[],
	  topicType: '',
	  keyword: '',
	  mobile: '',
	  industryType: {},
	  page:1,
	  value: 4.5,
	  currentTopicId: '',
	  currentTopicSrc: ''
    }
  },
  methods: {
	handleHover(item) {
	  this.currentTopicId = item.id;
	  this.currentTopicSrc = item.descImages;
	},
	toTopicDetail(id) {
	  this.$router.push({path: '/social/detail/' + id})
	},
    async getData(id){
    	const res = await getSoftList({page:this.page,limit:5,isSoftware:1,typeId:id,conSub:1})
    	if (res.code === 0) {
			this.dataList = res.data.list
			this.total = res.data.total

    	} else {
    	  this.$message.error(res.msg)
    	}
    },
	async getAnliData(){
		const res = await getList({displayPage:'软件超市'})
		if (res.code === 0) {
			this.anliList = res.data.list
		} else {
		  this.$message.error(res.msg)
		}
	},
	handleType(id){
		this.typeId = id
		this.getData(id)
	},
	// 软件分类
	async getTypeList(data){
		const res = await getType(data)
		if (res.code === 0) {
			if(data){
				this.subList = res.data.list[0].children
				this.typeId = this.subList[0].id
				this.typeName = this.subList[0].typeName
				this.getData(this.typeId)
			}else{
				this.typeList = res.data.list
				this.parentId = this.typeList[0].id
				this.parentName = this.typeList[0].typeName
				this.getTypeList({parentId:this.typeList[0].id})
			}
			
		} else {
		  this.$message.error(res.msg)
		}
	},
	//案例分类
	async getInsturyData(){
		const res = await getIndustry()
		if (res.code === 0) {
			for (var i = 0; i < res.data[0].dataList.length; i++) {
			  this.industryType[res.data[0].dataList[i].dictValue] = res.data[0].dataList[i].dictLabel
			}
		} else {
		  this.$message.error(res.msg)
		}
	},
	// 话题分类
	async getTypeData(){
		const res = await getTopicType()
		if (res.code === 0) {
			res.data.list.forEach((item)=>{
				res.data.list.forEach((item)=>{
					if(item.typeName == '热门资讯'){
						item.children.forEach((val)=>{
							if(val.typeName == '软件超市'){
								this.topicType = val.id
							}
						})
					}
				})
			})

			this.getDatalist()
		} else {
		  this.$message.error(res.msg)
		}
	},
	async getDatalist(){
		const res = await getTopicList({page:1,limit:10,typeId:this.topicType})
		if (res.code === 0) {
			this.list = res.data.list
			if (res.data.list && res.data.list.length > 0) {
			  this.currentTopicId = res.data.list[0].id
			  this.currentTopicSrc = res.data.list[0].descImages
			}
		} else {
		  this.$message.error(res.msg)
		}
	},
	toSoftDetail(id){
		localStorage.setItem('softType', JSON.stringify({parentId:this.parentId,parentName:this.parentName,typeId:this.typeId,typeName:this.typeName}))
		this.$router.push({name:'soft-detail',params:{id:id}})
	},
	toDetail(id){
		// if(getToken()){
			this.$router.push({ name: 'anli-detail', params: { id: id }})
		/* }else{
			toLogin(this)
		} */
	},
  },
  mounted () {
	this.getTypeList()
	this.getAnliData()
	this.getTypeData()
	this.getInsturyData()
  }

}
</script>

<style lang="scss" scoped>
.container{
	.page-top{
		background-color: #F6F9FF;
		.content{
			position: relative;
			padding: 150px 0 80px;
		}
		.title{
			font-size: 28px;
		}
		.tip{
			text-align: center;
			color: #4B4B4B;
			margin: 20px 0;
		}
	}
	.process{
		margin-top: 100px;
	}
	.wrapper{
		max-width: 1400px;
		width: 80vw;
		margin: 0 auto;
		.search{
			position: relative;
			width: 60%;
			margin:auto;
			/deep/.el-input__inner{
				border-radius: 20px;
				padding-left: 40px;
				border: none;
			}
			.el-button{
				position: absolute;
				right: 0;
				bottom: 0;
				background-color: #FF842E;
				width: 120px;
			}
		}
	}
	.soft-wrapper{
		max-width: 1400px;
		width: 80vw;
		.title{
			text-align: center;
			font-size: 24px;
			font-weight: bold;
			margin: 50px 0;
		}
		.el-tag {
		  transform: skewX(-10deg);
		  height: 22px;
		  line-height: 20px;
		  padding: 0 5px;
		  font-weight: 500;
		  margin-left: 10px;
		}
		.typeList{
			display: inline-block;
			width: 240px;
			height: 400px;
			margin-right: 20px;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
			background-image: url('../../assets/softWare/fenlei-bg.png');
			background-size:  240px 400px;
			padding: 15px 0;
			box-sizing: border-box;
			border-radius: 15px;
			.classify-item{
				font-size: 15px;
				color: #525252;
				cursor: pointer;
				padding: 8px 30px;
				// margin: 10px 0;
				position: relative;
				&.actived{
					background-color: rgba(255, 255, 255, 0.65);
					color: #FF8632;
					&::before{
						content: '';
						display: block;
						height: 20px;
						margin: 5px auto 0;
						border-left: 2px solid #FF8029;
						position: absolute;
						left: 0;
						top: 4px;
					}
				}
			}
		}
		.soft-content{
			display: inline-block;
			width: calc(100% - 260px);
			height: 400px;
			vertical-align: top;
			background-color: #fff;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
			border-radius: 15px;
			box-sizing: border-box;
			position: relative;
			.el-image.bg{
				position: absolute;
				bottom: -2px;
				right: 10px;
				width: 160px;
			}
		}
		.sub-type{
			display: inline-block;
			width: calc(100% - 40px);
			white-space: nowrap;
			overflow-x: scroll;
			padding: 20px 20px 0;
			border-bottom: 1px solid #E3E2E2;
			&::-webkit-scrollbar {
			    width: 6px;
			    height: 6px;
				display: none;
			}
			&::-webkit-scrollbar-thumb {
			    background-color: silver;
			    border-radius: 3px;
			}
			&::-webkit-scrollbar-track {
			    background-color: #f1f1f1;
			}
			.sub-item{
				display: inline-block;
				margin-right: 20px;
				font-size: 15px;
				color: #75777D;
				cursor: pointer;
				&:last-child{
					margin: 0;
				}
				&.actived{
					color: #383838;
					&::after{
						content: '';
						display: block;
						width: 30px;
						margin: 5px auto 0;
						border-bottom: 2px solid #FF8029;
					}
				}
			}
		}
		.softList{
			margin:10px 0;
			padding: 0 20px 20px;
			display: flex;
			flex-wrap: wrap;
			align-items: flex-start;
			&>div{
				display: inline-block;
				// width: 245px;
				flex: 0 0 calc(33% - 10px);
				vertical-align: top;
				margin-right: 10px;
				padding: 0 8px;
				box-sizing: border-box;
			}
			.soft-msg{
				cursor: pointer;
				border-right:  1px solid #E3E2E2;
				margin-bottom: 20px;
				&:nth-child(3n){
					border:none;
				}
				&>div{
					display: inline-block;
					vertical-align: top;
					&:nth-child(2){
						width: calc(100% - 70px);
					}
				}
				.logo{
					.el-image{
						width: 50px;
						height: 50px;
						border-radius: 8px;
						box-shadow:  0 0 10px rgba(0, 0, 0, 0.1);
					}
					margin-right: 20px;
				}
				.name{
					font-size: 18px;
					font-weight: 800;
					color: #3A404E;
					// margin: 5px 0;
				}
				.rate{
					margin-top: 5px;
				}
				.desc{
					font-size: 14px;
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					text-overflow: ellipsis;
					white-space: normal;
					margin-top: 5px;
				}
				.soft-btn{
					margin-top: 10px;
					.el-button{
						color: #FF8029;
						border: 1px solid #FF8029;
						border-radius: 20px;
						font-size: 15px;
						// width: 120px;
						&:hover{
							background-color: #FF8029;
							color: #fff;
						}
					}
				}
			}
			.btn{
				cursor: pointer;
				z-index: 1;
				padding: 10px;
				.more-title{
					font-size: 18px;
					font-weight: 800;
				}
				.more-tip{
					color: #505050;
					font-size: 15px;
				}
				.more-link{
					font-size: 14px;
					color: #505050;
					margin-top: 50px;
				}
			}
		}
	}
	.title{
		text-align: center;
		font-size: 24px;
		font-weight: 800;
	}
	.soft-hot{
		background-color: #F6F9FF;
		padding: 30px 0;
	}
	.comment{
		.desc{
			display: inline-block;
			width: 50%;
			vertical-align: top;
			margin-top: 80px;
			.title{
				text-align: left;
			}
			.tip{
				color: #606060;
				margin: 8px 0;
			}
			.input-wrapper{
				position: relative;
				width: 280px;
				margin: 20px 0;
				box-shadow: rgba(0, 0, 0, 0.05);
				/deep/.el-input__prefix{
					left: 12px;
					font-size: 16px;
				}
				/deep/.el-input__inner{
					border-radius: 20px;
					padding-left: 40px;
					border: none;
				}
				.el-button{
					position: absolute;
					right: 0;
					bottom: 0;
					background-color: #FF842E;
					width: 100px;
				}
			}
		}
		.image{
			display: inline-block;
			width: 50%;
			.el-image{
				width: 100%;
				height: 320px;
			}
		}
	}
	.anli,.comment{
		padding: 30px 0;
		background-color: #F6F9FF;
		margin: 50px auto;
	}
	.zixun{
		max-width: 1400px;
		width: 80vw;
		box-sizing: border-box;
		padding: 30px;
		background-color: #F6F9FF;
		border-radius: 20px;
		margin: 50px auto;
		.wrapper{
			width: 100%;
		}
	}
	.group-wrapper{
		margin: 50px 0;
		.group-image{
			display: inline-block;
			margin-top: 80px;
			margin-right: 20px;
			.el-image{
				width: 380px;
			}
		}
		.group-list{
			display: inline-flex;
			width: calc(100% - 400px);
			height: 500px;
			flex-direction: column;
			flex-wrap: wrap;
			justify-content: center;
			vertical-align: top;
			gap: 10px;
			.group-item{
				width: calc(50% - 20px);
				// flex: 0 0 30%;
				height: 150px;
				box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
				border-radius: 10px;
				padding: 20px;
				box-sizing: border-box;
				.group-title{
					color: #3A404E;
					font-weight: 800;
					font-size: 20px;
				}
				.group-desc{
					color: #626262;
					font-size: 15px;
					margin-top: 10px;
				}
			}
		}
	}
	.anli{
		.anli-wrapper{
			margin: 50px 0;
			display: grid;
			//flex-wrap: wrap;
			width: calc(100% - 45px);
			grid-template-columns: repeat(4, 25%);
			gap: 15px;
		}
		.btn{
			text-align: center;
			margin-top: 50px;
			.el-button{
				color: #FF842E;
			}
		}

		.anli-item{
		  transition: transform 0.3s ease;
		  // flex: 0 0 calc(25% - 30px);
		  // width: 300px;
		  background-color: #fff;
		  display: inline-block;
		  border-radius: 10px;
		  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.05), 0 6px 10px 0 rgba(0, 0, 0, 0.05);
		  // margin: 0 30px 30px 5px;
		  font-size: 14px;
		  position: relative;
		  padding-bottom: 60px;
		  &:nth-child(4n){
			margin-right: 0;
		  }
		  .cover-image{
			width: 100%;
			height: 180px;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
		  }
		  .title{
			font-size: 18px;
			font-weight: 700;
			width: 90%;
			margin: 25px auto 10px;
			text-align: left;
			letter-spacing: 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		  }
		  .abstrc{
			width: 90%;
			margin: 0 auto;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			text-overflow: ellipsis;
			white-space: normal;
		  }
		  .bottom{
			width: 90%;
			position: absolute;
			bottom: 20px;
			left:15px;
			.tag{
				background-color: #DBF9E5;
				color: #4BA162;
				padding: 3px 12px;
				border-radius: 5px;
				font-size: 12px;
				width: fit-content;
				display: inline-block;
			}
			.link{
				display: inline-block;
				float: right;
				cursor: pointer;
				.icon-bg{
					background-color: #FF842E;
					border-radius: 50%;
					width: 18px;
					height: 18px;
					line-height: 19px;
					display: inline-block;
					vertical-align: text-bottom;
					.el-icon-right{
						color: #fff;
					}
				}
			}
		  }
		}
		.anli-item:hover {
		  transform: translateY(-20px);
		}
	}
	.zixun .zixun-msg{
		background-color: #fff;
		border-radius: 8px;
		position: relative;
		padding: 30px;
		margin: 30px;
		min-height: 230px;
		.typeList{
			margin: 10px;
			.type-item{
				display: inline-block;
				cursor: pointer;
				font-size: 16px;
				background-color: #F5F5F5;
				width: 120px;
				height: 32px;
				line-height: 32px;
				border-radius: 20px;
				text-align: center;
				margin-right: 15px;
				&.active{
					background-color: #F6F1EE;
					color: #FF8632;
				}
			}
		}
		.topicList{
		  .topicItem {
			padding: 0 20px 0 20px;
			//transition: all .3s;
			cursor: pointer;
		  }
		  .topicItem:hover {
			padding: 20px;
			background: rgba(255, 132, 68, 0.05);
			border-radius: 20px;
		  }
		  .topicTitle {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 16px;
			margin-top: 8px;
			cursor: pointer;
		  }
		
		  .more {
			margin-top: 10px;
			font-size: 15px;
			cursor: pointer;
			color: #FF8632;
			margin-left: 20px;
		  }
		}
		
		.image {
		  //position: relative;
		  //top: 90px;
		  //right: 10px;
		  //width: 280px;
		
		  .el-image {
			width: 100%;
			height: 375px;
			border-radius: 30px;
		  }
		}
	}
	.process-wrapper{
		text-align: center;
		margin: 40px 0;
		&>div{
			display: inline-block;
			vertical-align: middle;
			margin-right: 25px;
			&:last-child{
				margin: 0;
			}
			&.process-item{
				text-align: center;
				.image{
					background-color: #fff;
					border-radius: 8px;
					.el-image{
						width: 50px;
						height: 50px;
					}
				}

			}
			.iconfont{
				color: #C4C4C4;
				font-size: 20px;
			}
		}
	}
	.service{
		max-width: 1400px;
		width: 80vw;
		box-sizing: border-box;
		padding: 30px 60px;
		background-color: #F6F9FF;
		border-radius: 20px;
		margin: 50px auto;
		.wrapper{
			width: fit-content;
		}
		.item-wrapper{
			margin: 50px 0;
			display: flex;
		}
		.item{
			background-color: #fff;
			border-radius: 10px;
			display: inline-block;
			padding: 20px;
			box-sizing: border-box;
			flex: 0 0 49%;
			position: relative;
			background-image: url('../../assets/image.png');
			background-position: right bottom;
			background-repeat: no-repeat;
			background-size: 150px 150px;
			&:first-child{
				margin-right: 2%;
			}
			.item-title{
				color: #404040;
				font-size: 20px;
				font-weight: 800;
				margin-bottom: 20px;
			}
			.content{
				color:#45494F;
				font-size: 16px;
				margin-bottom: 80px;
			}
			.button{
				border: 1px solid #FF842E;
				color: #FF842E;
				border-radius: 20px;
				width: 100px;
				text-align: center;
				margin: 20px 0 10px;
				cursor: pointer;
				position: absolute;
				left: 20px;
				bottom: 40px;
			}
		}
	}
	.page-bottom{
		width: 100%;
		margin: 50px 0;
		position: relative;
		.content{
			width: 50%;
			position: absolute;
			top: 70px;
			left: 50%;
			// right: 0;
			margin-left: -25%;
			text-align: center;
			.title{
				font-size: 28px;
				font-weight: bold;
				margin: 20px 0;
				text-align: center;
			}
			.process{
				color: #454851;
				font-size: 14px;
				margin-bottom: 20px;
				margin-top: 0;
			}
			.iconfont{
				color: #BEBFC0;
				margin: 0 10px;
			}
			.input-wrapper{
				position: relative;
				max-width: 450px;
				margin: auto;
				.el-input{
					/deep/.el-input__inner{
						border-radius: 20px;
						padding-left: 25px;
					}

				}
				/deep/.el-input.is-active .el-input__inner,
				/deep/.el-input__inner:focus{
					border-color: #C0C4CC;
				}
				.el-button--warning{
					background-color: #FF842E;
				}
			}
			.btn{
				position: absolute;
				bottom: 0;
				right: 0;
				border-radius: 20px;
				padding: 12px 32px;
			}

		}
	}
}
@media (min-width: 1025px) and (max-width: 1260px) {
.container{
	.page-bottom{
		.content{
			top: 50px;
			.title{
				font-size: 24px;
				margin: 20px 0;
			}

		}
	}
}
}
@media (min-width: 768px) and (max-width: 1024px) {
.container{
	.page-bottom{
		.content{
			top: 15px;
			.title{
				font-size: 24px;
				margin: 20px 0;
			}

		}
	}
}

}
@media screen and (max-width: 767px) {
.container{
	.wrapper{
	  width: calc(100vw - 20px);
	}
	.page-top {
	  padding: 50px 0;
	  .content{
		  padding: 0;
	  }
	  .search {
	    width: 95%;
	    /deep/ .el-input__inner {
	      padding-left: 20px;
	    }
	    .el-button {
	      width: 100px;
	    }
	  }
	}
	.comment{
		.desc{
			display: block;
			width: calc(100% - 80px);
			vertical-align: top;
			margin: 0 auto;
			text-align: center;
			.input-wrapper{
				width: 100%;
			}
		}
		
		.image{
			display: block;
			width: 100%;
			.el-image{
				width: 100%;
				height: 320px;
			}
		}
	}
	.group-wrapper{
		margin: 50px 0;
		.group-image{
			display: block;
			margin-top: 30px;
			margin-right: 0;
			.el-image{
				width: 100%;
			}
		}
		.group-list{
			display: inline-flex;
			width: 100%;
			height: 640px;
			flex-wrap: wrap;
			justify-content: flex-start;
			vertical-align: top;
			gap: 20px;
			.group-item{
				width: calc(50% - 10px);
				height: 195px;
				padding: 20px;
				box-sizing: border-box;
				.group-title{
					color: #3A404E;
					font-weight: 800;
					font-size: 18px;
				}
			}
		}
	}
	.service{
		width: calc(100vw - 20px);
		margin: 50px auto;
		padding: 30px 20px;
		.item-wrapper{
			margin: 30px 0;
			display: block;
		}
		.item{
			margin-bottom: 20px;
			margin-right: 0 !important;
			display: block;
		}
	}
	.anli {
		width: 100vw;
		padding: 30px 0;
		padding-bottom: 30px;
	    .anli-wrapper {
	      margin: 30px 0;
	      display: block;
		  padding: 0 20px;
		  box-sizing: border-box;
	      width: 100%;
		  .title{
			  font-size: 24px;
		  }
	    }
	    .anli-item {
			display: block;
			width: 100%;
			margin-bottom: 20px;
		}
	}
	.zixun {
		width: calc(100vw - 20px);
		padding: 30px 10px;
		.zixun-msg {
		  	display: block !important;
			padding: 8px 8px 5px 15px !important;
			margin: 30px 0;
			.image{
				.el-image{
					height: 245px;
				}
			}
		}
		
	}
	.page-bottom{
		.content{
			top: 15px;
			.title{
				font-size: 18px;
				margin: 10px 0;
			}
			.process{
				margin-bottom: 10px;
			}
			.input-wrapper{
				position: relative;
				.el-input{
					/deep/.el-input__inner{
						font-size: 12px;
						height: 30px;
						line-height: 30px;
					}
				}
			}
			.btn{
				position: absolute;
				bottom: 0;
				right: 0;
				border-radius: 20px;
				padding: 0 32px;
				height: 30px;
				line-height: 30px;
			}
		}
	}
}

}

</style>
